import { FC, Props } from "./typings";
import styles from "./styles.module.scss";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import CloseIcon from "assets/icons/close.svg?react";
import { SignalRContext } from "../../App";
import {
  HubCallbacksNames,
  IImportProgress,
  ImportStatus,
  ImportStep,
} from "api/hub";
const SyncStatusPopup: FC<Props> = () => {
  const { t } = useTranslation();
  const [isPiSyncActive, setIsPiSyncActive] = useState<boolean>(false);
  const [isEmailSyncActive, setIsEmailSyncActive] = useState<boolean>(false);

  const isInIncomingList = window.location.href.includes("incoming");

  const [emailDesc, setEmailDesc] = useState<string>(
    t("sync.incomingInProgress")
  );
  const [piDesc, setPiDesc] = useState<string>(null);

  const [emailCurrent, setEmailCurrent] = useState<number>(0);
  const [emailTotal, setEmailTotal] = useState<number>(0);

  const [piCurrent, setPiCurrent] = useState<number>(0);
  const [piTotal, setPiTotal] = useState<number>(0);

  SignalRContext.useSignalREffect(
    HubCallbacksNames.PIImportProgress,
    (message: IImportProgress) => {
      if (message.step === ImportStep.Email) {
        if (
          message.status === ImportStatus.Starting ||
          message.status === ImportStatus.Running
        ) {
          setIsEmailSyncActive(true);
          setEmailDesc(message.message);
          setEmailCurrent(message.current);
          setEmailTotal(message.total);
        } else {
          setIsEmailSyncActive(false);
        }
      } else {
        if (
          message.status === ImportStatus.Starting ||
          message.status === ImportStatus.Running
        ) {
          setIsPiSyncActive(true);
          setPiDesc(
            message.portalName
              ? message.portalName + ": " + message.message
              : message.message
          );
          setPiCurrent(message.current);
          setPiTotal(message.total);
        } else {
          setIsPiSyncActive(false);
        }
      }
    },
    []
  );

  return (
    <div className={`${styles.wrapper}`}>
      {isInIncomingList && isEmailSyncActive && (
        <div className={styles.syncStatus}>
          <div className={styles.name}>{emailDesc}</div>
          {emailTotal > 0 && (
            <div className={styles.counters}>
              {emailCurrent}/{emailTotal}
            </div>
          )}
          <CloseIcon
            onClick={() => {
              setIsEmailSyncActive(false);
            }}
            className={styles.closeIcon}
          />

          <div className={styles.progressBg}></div>
          {emailTotal > 0 && (
            <div
              className={styles.progress}
              style={{ width: `${(emailCurrent * 100) / emailTotal}%` }}
            ></div>
          )}
        </div>
      )}

      {isInIncomingList && isPiSyncActive && (
        <div className={styles.syncStatus}>
          <div className={styles.name}>{piDesc}</div>
          {piTotal > 0 && (
            <div className={styles.counters}>
              {piCurrent}/{piTotal}
            </div>
          )}
          <CloseIcon
            onClick={() => {
              setIsPiSyncActive(false);
            }}
            className={styles.closeIcon}
          />
          <div className={styles.progressBg}></div>
          {piTotal > 0 && (
            <div
              className={styles.progress}
              style={{ width: `${(piCurrent * 100) / piTotal}%` }}
            ></div>
          )}
        </div>
      )}
    </div>
  );
};

export default SyncStatusPopup;
